import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04abe56f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "rednote-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-background"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_top_back.png",
  alt: "顶部背景",
  class: "top-bg-image"
})], -1));
const _hoisted_3 = {
  class: "main-content"
};
const _hoisted_4 = {
  class: "status-wrapper"
};
const _hoisted_5 = {
  class: "status-text"
};
const _hoisted_6 = {
  key: 0,
  src: "https://p6.moimg.net/mdwxapp/xhs_arrow.png",
  alt: "箭头",
  class: "arrow-icon"
};
const _hoisted_7 = {
  class: "title-section"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-quote"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_top_title_right.png",
  alt: "引号",
  class: "quote-icon"
})], -1));
const _hoisted_9 = {
  key: 0,
  class: "activity-title"
};
const _hoisted_10 = {
  class: "rednote-activity-section"
};
const _hoisted_11 = {
  class: "activity-background"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_activity_back.png",
  alt: "小红书种草活动",
  class: "activity-bg-image"
}, null, -1));
const _hoisted_13 = {
  class: "activity-overlay"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "activity-heading"
}, "小红书种草活动", -1));
const _hoisted_15 = {
  class: "participation-text"
};
const _hoisted_16 = {
  class: "prize-card"
};
const _hoisted_17 = {
  key: 0,
  class: "review-approval-status"
};
const _hoisted_18 = {
  key: 1,
  class: "prize-display"
};
const _hoisted_19 = {
  class: "current-prize-detail"
};
const _hoisted_20 = {
  class: "prize-image-container"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "prize-details"
};
const _hoisted_23 = {
  class: "prize-header"
};
const _hoisted_24 = {
  class: "prize-name"
};
const _hoisted_25 = {
  key: 0,
  src: "https://p6.moimg.net/mdwxapp/xhs_arrow.png",
  alt: "箭头",
  class: "detail-arrow"
};
const _hoisted_26 = {
  class: "prize-meta"
};
const _hoisted_27 = {
  class: "prize-quantity"
};
const _hoisted_28 = {
  key: 0,
  class: "prize-quantity"
};
const _hoisted_29 = {
  key: 1,
  class: "prize-tags"
};
const _hoisted_30 = {
  key: 0,
  class: "prize-price"
};
const _hoisted_31 = {
  key: 0,
  class: "prizes-bottom-list"
};
const _hoisted_32 = {
  class: "prizes-carousel"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "prize-item-image"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  class: "prize-count-info"
};
const _hoisted_37 = {
  class: "count-text"
};
const _hoisted_38 = {
  class: "activity-time"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "time-label"
}, "活动结束", -1));
const _hoisted_40 = {
  class: "time-value"
};
const _hoisted_41 = {
  key: 0,
  class: "project-tag"
};
const _hoisted_42 = {
  class: "project-title"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_arrow.png",
  alt: "箭头",
  class: "project-arrow"
}, null, -1));
const _hoisted_44 = {
  class: "info-blocks"
};
const _hoisted_45 = {
  class: "info-block requirement-block"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "block-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_need.png",
  alt: "参与要求",
  class: "block-title-image"
})], -1));
const _hoisted_47 = {
  class: "block-content"
};
const _hoisted_48 = {
  class: "requirement-text"
};
const _hoisted_49 = {
  class: "info-block lottery-block"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "block-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/xhs_prize_type.png",
  alt: "开奖方式",
  class: "block-title-image"
})], -1));
const _hoisted_51 = {
  class: "block-content"
};
const _hoisted_52 = {
  class: "lottery-rule"
};
const _hoisted_53 = {
  key: 0,
  class: "lottery-time"
};
const _hoisted_54 = {
  class: "fixed-bottom-bar"
};
const _hoisted_55 = {
  class: "steps-guide"
};
const _hoisted_56 = {
  class: "action-button-group"
};
const _hoisted_57 = ["disabled"];
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-divider"
}, null, -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "safe-area-spacer"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [$data.prizeModel.activity_info.status !== 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "activity-status",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handlePrizeResult && $options.handlePrizeResult(...args))
  }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($options.getStatusText()), 1), $data.prizeModel.activity_info.status === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_hoisted_8, $data.prizeModel.activity_info.title ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString($data.prizeModel.activity_info.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("p", _hoisted_15, _toDisplayString($data.prizeModel.activity_info.join_number) + "人参与", 1)])])]), _createElementVNode("div", _hoisted_16, [$data.prizeModel.activity_info.prize_type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_van_image, {
    class: "cover",
    src: "https://p6.moimg.net/wxapp/prize_rednote_review.png"
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "prize-showcase",
    onClick: _cache[1] || (_cache[1] = $event => $options.handlePrizeClick())
  }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
    src: $options.getCurrentPrize().img || '/src/assets/images/placeholder/default_1x1@2x.png',
    alt: "奖品图片",
    class: "prize-image"
  }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("h3", _hoisted_24, _toDisplayString($options.getCurrentPrize().prize_name), 1), $options.getCurrentPrize().jump_url ? (_openBlock(), _createElementBlock("img", _hoisted_25)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString($options.getCurrentPrize().num) + "个", 1), $options.getCurrentPrize().relation_type === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "赠品")) : _createCommentVNode("", true), $options.getCurrentPrize().relation_type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_29, "购买权")) : _createCommentVNode("", true)]), $options.getCurrentPrize().price ? (_openBlock(), _createElementBlock("div", _hoisted_30, " ¥" + _toDisplayString($options.getCurrentPrize().price), 1)) : _createCommentVNode("", true)])])]), $data.prizeModel.prize_list.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.prizeModel.prize_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["prize-item", {
        active: $data.selectedPrizeIndex === index
      }]),
      onClick: $event => $options.selectPrize(index)
    }, [_createElementVNode("div", _hoisted_34, [_createElementVNode("img", {
      src: item.img || '/src/assets/images/placeholder/default_1x1@2x.png',
      alt: "奖品"
    }, null, 8, _hoisted_35)])], 10, _hoisted_33);
  }), 128))]), _createElementVNode("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, _toDisplayString($data.prizeModel.prize_list.length) + "款共" + _toDisplayString($options.getTotalPrizeCount()) + "个", 1)])])) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString($data.prizeModel.activity_info.end_time), 1)])]), _createElementVNode("div", {
    class: "project-card",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleProjectClick && $options.handleProjectClick(...args))
  }, [$data.prizeModel.item_info.item_type_name ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($data.prizeModel.item_info.item_type_name), 1)) : _createCommentVNode("", true), _createElementVNode("h3", _hoisted_42, _toDisplayString($data.prizeModel.item_info.title), 1), _hoisted_43]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, [_createElementVNode("p", _hoisted_48, _toDisplayString($data.prizeModel.activity_info.describe), 1)])]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("p", _hoisted_52, "开奖方式：" + _toDisplayString($data.prizeModel.activity_info.draw_rule), 1), $data.prizeModel.activity_info.on_time_distribute_txt ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString($data.prizeModel.activity_info.on_time_distribute_txt), 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_van_image, {
    src: "https://p6.moimg.net/mdwxapp/xhs_step.png",
    alt: "操作步骤",
    class: "steps-image"
  })]), _createElementVNode("div", _hoisted_56, [_createElementVNode("button", {
    class: "action-button secondary-button",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.handleRedNoteShare && $options.handleRedNoteShare(...args))
  }, " 获取素材 "), _createElementVNode("button", {
    class: _normalizeClass(["action-button primary-button", {
      disabled: $data.prizeModel.activity_info.status !== 0
    }]),
    disabled: $data.prizeModel.activity_info.status !== 0,
    onClick: _cache[4] || (_cache[4] = (...args) => $options.handleUploadLink && $options.handleUploadLink(...args))
  }, _toDisplayString($data.prizeModel.activity_info.rednote_link ? '已上传链接' : '上传小红书笔记链接'), 11, _hoisted_57)]), _hoisted_58]), _hoisted_59]);
}